import { createReducer, on } from '@ngrx/store';
import { setSavedAnalysisPlanId } from './saved-analysis-plan-id.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
export const savedAnalysisPlanId = createReducer(null, on(setSavedAnalysisPlanId, (state, action) => {
    return action.savedAnalysisPlanId;
}), on(resetAllCustomPdfReportItems, () => {
    return null;
}));
